module.exports = __webpack_public_path__ + "img/image08.a02a2bdc.jpg";